import * as React from 'react';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';

const Error = (props) => { 
    return (
        <div className="main">
            <MetaTags>
                <title>{`Error - LoudUp`}</title>
            </MetaTags> 
            <div className="container">
                <div className="block-inner">
                    <div className="row">
                        <div className="col-sm-8 col-sm-push-2">
                            <div className="errorbox">
                                <svg className="icon icn-error transition">
                                    <use xlinkHref="#icn-error" />
                                </svg>
                                <h2>Error</h2>
                                <p>An error occurred while processing your request. 
                                <br />
                                <br />
                                Please <Link to="/">click here</Link> to return to the homepage or <Link to="/Contact">contact us</Link> to report the error.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Error;